function matchDistrict(state, school) {
  if (!state.districtNumber) return false;
  return school.subdistrict == state.districtNumber;
}

export default function markerFilter(state, schools) {
  let filters = [
    matchDistrict
  ];
  let survivors = schools.slice();
  for (let fn of filters) {
    survivors = survivors.filter(s => fn(state, s));
  }
  return new Set(survivors);
}